export default __webpack_public_path__ + "static/media/amksoanim.0ed2354f.png";